import React, { useEffect, createContext, useState } from "react";

export const AppContext = createContext();

const AppContextProvider = (props) => {
  const [authUser, setAuthUser] = useState(false);
  const [activeMenu, setActiveMenu] = useState("home");
  const [fullPageLoading, setFullPageLoading] = useState(true);
  const [appConfig, setAppConfig] = useState({});

  useEffect(() => {
    setTimeout(() => {
      setFullPageLoading(false);
    }, 1500);
  }, []);

  const setAppConfigWrapper = (obj = {}) => {
    if (JSON.stringify(appConfig) !== JSON.stringify(obj)) {
      setAppConfig({ ...appConfig, ...obj });
    }
  };

  return (
    <AppContext.Provider
      value={{
        authUser,
        setAuthUser,
        activeMenu,
        setActiveMenu,
        fullPageLoading,
        setFullPageLoading,
        appConfig,
        setAppConfigWrapper,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
